// Show people in rough order of how likely they are to go to the showing.
// Confirmed agents and prospects go at the top, above the fold.
export const showingStatusSort: string[] = [
  'CONFIRMED',
  'CONFIRMED_NOSYNC',
  'CONFIRM_SENT',
  'ACCEPTED',
  'OFFERED',
  'AVAIL',
  'REJECTED',
  'DISQUALIFIED',
  'CANCEL_BY_US',
  'CANCEL_BY_THEM',
  'CANCEL_BY_THEM_NOSYNC',
  'NO_SHOW',
  'NOT_AVAIL',
]
